export type SnowplowPixelPlatform =
  | 'facebook'
  | 'snapchat'
  | 'tiktok'
  | 'bing'
  | 'criteo'
  | 'rtbHouse';

export const SNOWPLOW_PIXEL_EVENT_MAPPING = {
  // 搜索结果事件-对应 GA4：search
  IsReturn_Result: ['facebook', 'snapchat', 'tiktok', 'bing', 'criteo', 'rtbHouse'],

  // 商详页浏览事件-对应 GA4：view_item
  ProductDetailsPage_View: ['facebook', 'snapchat', 'tiktok', 'bing', 'criteo', 'rtbHouse'],

  // 加购事件-对应 GA4：add_to_cart
  AddToCart_Result: ['facebook', 'snapchat', 'tiktok', 'bing', 'criteo', 'rtbHouse'],

  // 心愿单-对应 GA4：add_to_wishlist
  CollectBtn_Click: ['facebook', 'snapchat', 'tiktok', 'bing', 'criteo', 'rtbHouse'],

  // 支付页浏览-对应 GA4: generate_lead
  PlaceOrderPage_View: ['facebook', 'snapchat', 'tiktok', 'bing', 'criteo', 'rtbHouse'],

  // 创建订单成功-对应 GA4：begin_checkout
  PlaceOrderPagePlaceOrder_Result: ['facebook', 'snapchat', 'tiktok', 'bing', 'criteo', 'rtbHouse'],

  // 支付成功页浏览-对应 GA4：purchase
  PlaceOrderSuccessPage_View: ['facebook', 'snapchat', 'tiktok', 'bing', 'criteo', 'rtbHouse'],

  // 兼容历史 Purchase 事件名，对应 GA4：purchase
  Purchase: ['facebook', 'snapchat', 'tiktok', 'bing', 'criteo', 'rtbHouse'],

  // 注册成功-对应 GA4：sign_up
  LoginSuccessNew_Result: ['facebook', 'snapchat', 'tiktok', 'bing'],

  // 登录成功-对应 GA4：login
  LoginSuccess_Result: ['facebook', 'snapchat', 'tiktok', 'bing'],
} as const satisfies Record<string, readonly SnowplowPixelPlatform[]>;

export function resolveSnowplowPixels(eventName?: string): SnowplowPixelPlatform[] {
  if (!eventName) {
    return [];
  }

  const pixels =
    SNOWPLOW_PIXEL_EVENT_MAPPING[eventName as keyof typeof SNOWPLOW_PIXEL_EVENT_MAPPING];

  return pixels ? [...pixels] : [];
}
